import styled from 'styled-components';

export const WideContainer = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${(props) => props.theme.background};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  grid-column: span 2;
`;

export const LeftPanel = styled.div`
  background-color: ${({ theme }) => theme.backgroundLightest};
  padding: 30px 40px;
  flex: 0 0 50%;

  h3 {
    color: ${({ theme }) => theme.textDark};
    font-size: 40px;
    line-height: 46px;

    span {
      color: ${({ theme }) => theme.primary};
    }
  }
`;

export const RightPanel = styled.div`
  flex: 0 0 50%;
  padding: 30px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CheckWrapper = styled.div`
  width: 100%;
  max-width: 320px;
  margin-top: -60px;
`;

export const WideCheckRow = styled.p`
  color: ${({ theme }) => theme.textDark};
  margin: 15px 0;
  display: flex;
  align-items: flex-start;
  font-size: 20px;

  svg {
    margin-top: 6px;
    margin-right: 10px;
  }
`;

export const CheckRow = styled.p`
  color: ${({ theme }) => theme.textDark};
  margin: 15px 0;
  font-size: 16px;
  text-align: center;

  svg {
    margin-right: 10px;
  }
`;

export const Container = styled.div`
  position: relative;
  background-color: ${(props) => props.theme.background};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
`;

export const Content = styled.div`
  position: relative;
  z-index: 2;
  padding: 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  h3 {
    color: ${({ theme }) => theme.textDark};
    font-size: 32px;
    line-height: 40px;
    text-align: center;
    max-width: 350px;
    width: 100%;
    margin: 0 auto;

    span {
      color: ${({ theme }) => theme.primary};
    }
  }

  a {
    width: 100%;
    max-width: 290px;
    display: block;
    margin: 0 auto;
  }
`;

export const Bg = styled.div`
  background-color: ${({ theme }) => theme.backgroundLightest};
  aspect-ratio: 880 / 645;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
`;

export const WidePromoImage = styled.img`
  margin-top: 30px;
  width: 130%;
  margin-left: -30px;
`;

export const PromoImage = styled.img`
  width: 100%;
  margin-top: 10px;
`;
